var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('m-assembly-table',{ref:"pageForm",attrs:{"formData":_vm.formData,"columns":_vm.columns,"data":_vm.tableData,"tableButtons":_vm.tableButtons,"loading":_vm.loading,"currentPage":_vm.settings.currentPage,"pageSize":_vm.settings.pageSize,"total":_vm.settings.total,"settings":_vm.settings}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }